import styled from "styled-components";

const RewardDescriptionWrapper = styled.span`
  font: ${props => props.theme.typography.fontFamily};
  font-weight: 600;
  font-size: 1.3rem;
  color: ${props => props.color ?? props.theme.colors.textColor};
  margin-left: 1rem;
  display: inline-block;
  text-align: left;
`;

export default RewardDescriptionWrapper;
